// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

var appendTimestampLocStorKey = "export-to-json-append-timestamp";

function MM_cmp_export_state_to_json(Props) {
  var jsonStr = Props.jsonStr;
  var onClose = Props.onClose;
  var match = React.useState(function () {
        return Belt_Option.getWithDefault(Local_storage_utils.locStorReadBool(appendTimestampLocStorKey), false);
      });
  var setAppendTimestampPriv = match[1];
  var appendTimestamp = match[0];
  var setAppendTimestamp = function (appendTimestamp) {
    Local_storage_utils.locStorWriteBool(appendTimestampLocStorKey, appendTimestamp);
    Curry._1(setAppendTimestampPriv, (function (param) {
            return appendTimestamp;
          }));
  };
  var timestampStr = appendTimestamp ? Common.currTimeStr(undefined) + " " : "";
  var textToShow = timestampStr + jsonStr;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(Expln_React_Row.make, {
                        spacing: 1,
                        children: null
                      }, React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: appendTimestamp,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool(setAppendTimestamp, param);
                                    })
                                }),
                            label: "append timestamp"
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                MM_react_common.copyToClipboard(textToShow);
                              }),
                            variant: "contained",
                            children: "Copy"
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              }),
                            children: "Close"
                          })), React.createElement("pre", {
                        style: {
                          overflow: "auto"
                        }
                      }, textToShow))
            });
}

var make = MM_cmp_export_state_to_json;

exports.appendTimestampLocStorKey = appendTimestampLocStorKey;
exports.make = make;
/* react Not a pure module */
